module.exports = __webpack_public_path__ + "static/media/sweet_2.a653d6b4.png";